module.exports = __webpack_public_path__ + "img/mh.8842e6e9.svg";